import dynamic from 'next/dynamic';
import { ButtonProps, ChakraProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Form as FormProps } from '../../types';

const ServiceOfferForm = dynamic(() => import('./ServiceOfferForm'), {
  ssr: false,
});
const MembershipForm = dynamic(() => import('./MembershipForm'), {
  ssr: false,
});
const ContactForm = dynamic(() => import('./ContactForm'));
const FeedbackForm = dynamic(() => import('./FeedbackForm'));
const AddressChangeForm = dynamic(() => import('./AddressChangeForm'));

interface Props extends FormProps {
  children?: (closeButtonProps?: ButtonProps) => ReactNode;
  title?: string;
}

const FormSelector = ({ type, slots, ...rest }: Props & ChakraProps) => {
  switch (type) {
    case 'service_offer':
      return <ServiceOfferForm type={type} {...rest} />;
    case 'membership':
      return <MembershipForm type={type} {...rest} />;
    case 'contact':
      return <ContactForm type={type} {...rest} />;
    case 'feedback':
      return <FeedbackForm type={type} {...rest} />;
    case 'address':
      return <AddressChangeForm type={type} {...rest} />;
    default:
      throw new Error(`No such form type ${type}`);
  }
};

export default FormSelector;
